import { connect } from 'react-redux';
import News, {
  NewsProps,
} from '@/components/DeprecatedPortfolio/components/News';
import { getLatestPortfolioNews } from '@/components/DeprecatedPortfolios/redux/selectors';

type StateProps = Pick<NewsProps, 'listing'>;
const mapStateToProps = (state): StateProps => {
  const latestNews = getLatestPortfolioNews(state);
  return {
    listing: latestNews,
  };
};

type ContainerProps = Pick<NewsProps, 'sectionNumber'>;
export default connect<StateProps, unknown, ContainerProps>(mapStateToProps)(
  News
);
